import { render, staticRenderFns } from "./small_loader.vue?vue&type=template&id=6b157eb0&"
import script from "./small_loader.vue?vue&type=script&lang=js&"
export * from "./small_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports